module.exports = __webpack_public_path__ + "img/yl3075.38407352.png";